import React, { useState } from "react";
import { useFormik, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  TextField,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
  FormLabel,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';


const validationSchema = Yup.object({
  applicantName: Yup.string().required("Applicant Name is required"),
  cnicNumber: Yup.string()
    .matches(/^\d{13}$/, "CNIC must be 13 digits")
    .required("CNIC is required"),
  address: Yup.string().required("Address is required"),
  email: Yup.string().email("Invalid email format").required("Email is required"),
  contact: Yup.string().matches(/^\d{10}$/, "Contact must be 10 digits"),
  age: Yup.string().matches(/^\d{1,3}$/, "Invalid age"),
  secondarySchool: Yup.string().required("Secondary School is required"),
  higherSchool: Yup.string().required("Higher School is required"),
  university: Yup.string().required("University is required"),
  discipline: Yup.string().required("Discipline is required"),
  degree: Yup.string().required("Degree is required"),
  nameOfInstitute: Yup.string().required("Name of Institute is required"),
  recognizedBy: Yup.string().required("Recognized By is required"),
  tuitionFee: Yup.number().required("Tuition Fee is required"),
  admissionFee: Yup.number().required("Admission Fee is required"),
  tuitionFeeW: Yup.string().required("Tuition Fee in Words is required"),
  fatherName: Yup.string().required("Father Name is required"),
  f_Cnic:Yup.string().matches(/^\d{13}$/, "CNIC must be 13 digits").required("CNIC is required"),
  P_occupation:Yup.string().required("Occupation is required"),
  P_m_income:Yup.number().required("Income is required"),
  employer:Yup.string().required("Employer is required"),
  designation:Yup.string().required("Designation is required"),
  family_members:Yup.number().required("Family Members is required"),
  P_contact:Yup.string().matches(/^\d{10}$/, "Contact must be 10 digits"),
  M_pension:Yup.string().required("Pension is required"),
  M_monthlyIncome:Yup.number().required("Income is required"),
  s1:Yup.string().required("Sibling is required"),
  s2:Yup.string().required("Sibling is required"),
  s3:Yup.string().required("Sibling is required"),
  s4:Yup.string().required("Sibling is required"),
  institue1:Yup.string().required("Institute is required"),
  institue2:Yup.string().required("Institute is required"),
  institue3:Yup.string().required("Institute is required"),
  institue4:Yup.string().required("Institute is required"),
  occ1:Yup.string().required("Occupation is required"),
  occ2:Yup.string().required("Occupation is required"),
  occ3:Yup.string().required("Occupation is required"),
  occ4:Yup.string().required("Occupation is required"),
  fee1:Yup.number().required("Fee is required"),
  fee2:Yup.number().required("Fee is required"),
  fee3:Yup.number().required("Fee is required"),
  fee4:Yup.number().required("Fee is required"),
  monthly_rent:Yup.number().required("Enter Monthly Rent here"),
  telephone:Yup.string().matches(/^\d{10}$/, "telephone must be 10 digits"),
  gas:Yup.number().required("Gas bill is required"),
  water:Yup.number().required("water bill is required"),
  stationary:Yup.number().required("Stationary is required"),
  other:Yup.number().required("Other is required"),
  appartment:Yup.string().required("If appartment input yes"),
  house:Yup.string().required("if house input yes"),
  family_owned:Yup.string().required("if family owned input yes"),
  rented:Yup.string().required("If rented input yes"),
  joint_family:Yup.string().required("If joint family input  yes"),
  independent_family:Yup.string().required("If independent family input yes"),
  amount_outstanding:Yup.number().required("amount outstanding is required"),
  nature_of_loan:Yup.string().required("nature of loan is required"),
  
  
});

const App = () => {
  const [tableData, setTableData] = useState([
    { id: 1, nameOfInstitute: "", totalAmount: "", duration: "", degree: "" },
  ]);
  const [familyTableData, setFamilyTableData] = useState([
    {
      id: 1, dependant: '',age: '', occupation: '',nameOfInstitute: '',feePerMonth: '',others: '',
    },
  ]);
  const [familyincomeTableData, setFamilyIncomeTableData] = useState([
    { id: 1, incomeSource: 'Salary', father: '', mother: '', spouse: '', self: '', others: '', total: '' },
    { id: 2, incomeSource: 'Business', father: '', mother: '', spouse: '', self: '', others: '', total: '' },
  ]);

  const handleTableChange = (id: number, field: string, value: string) => {
    setTableData((prevData) =>
      prevData.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };
  const handlefamilyTableChange = (id:number, field: string, value:string) => {
    const updatedData = familyTableData.map((row) =>
      row.id === id ? { ...row, [field]: value } : row
    );
    setFamilyTableData(updatedData);
  };
  const handlefamilyincomeTableChange = (id:number, field: string, value:string) => {
    const updatedData2 = familyincomeTableData.map(row =>
      row.id === id ? { ...row, [field]: value } : row
    );
    setFamilyIncomeTableData(updatedData2);
  };
  const handleDeleteRow = (id:number) => {
    const updatedData = tableData.filter((row) => row.id !== id);
    setTableData(updatedData);
  };
  const handleDeleteRow2 = (id:number) => {
      const updatedData2 = familyTableData.filter((row) => row.id !== id);
      setFamilyTableData(updatedData2);
    };
  const addRow = () => {
    const newRow = {
      id: tableData.length + 1,
      nameOfInstitute: '',
      totalAmount: '',
      duration: '',
      degree: '',
    };
    setTableData([...tableData, newRow]);
  };
  const add2Row = () => {
    const newRow = {
      id: familyTableData.length + 1,
      dependant: '',
      age: '',
      occupation: '',
      nameOfInstitute: '',
      feePerMonth: '',
      others: '',
    };
    setFamilyTableData([...familyTableData, newRow]);
  };

  
  const formik = useFormik({
    initialValues: {
      applicantName: "",
      cnicNumber: "",
      address: "",
      email: "",
      contact: "",
      age: "",
      gender: "male",
      secondarySchool: "",
      higherSchool: "",
      university: "",
      discipline: "",
      degree: "",
      nameOfInstitute: "",
      recognizedBy: "",
      tuitionFee: "",
      admissionFee: "",
      tuitionFeeW: "",
      otherPercentage: "",
      hasScholarship: false,
      fatherName: "",
      f_Cnic: "",
      P_occupation: "",
      P_m_income: "",
      employer: "",
      designation: "",
      family_member: "",
      pension: "",
      P_contact: "",
      M_pension: "",
      M_monthlyIncome: "",
      s1:"",
      s2:"",  
      s3:"",
      s4:"",
      institue1:"",
      institue2:"",
      institue3:"",
      institue4:"",
      occ1:"",
      occ2:"",
      occ3:"",
      occ4:"",
      fee1:"",
      fee2:"",
      fee3:"",
      fee4:"",
      monthly_rent:"",
      telephone:"",
      gas:"",
      electricity:"",
      water:"",
      stationary:"",
      other:"",
      appartment:"",
      house:"",
      family_owned:"",
      rented:"",
      joint_family:"",
      independent_family:"",
      amount_outstanding:"",
      nature_of_loan:"",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log("Form Submitted: ", values);
      console.log("Table Data: ", tableData);
    },
  });

  return (
    <div className="App">
      <h1>Application Form</h1>
      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={4}>
            <Grid item xs={12} >
              <TextField
                fullWidth
                label="Applicant Name"
                name="applicantName"
                value={formik.values.applicantName}
                onChange={formik.handleChange}
                error={formik.touched.applicantName && Boolean(formik.errors.applicantName)}
                helperText={formik.touched.applicantName && formik.errors.applicantName}
              />
            </Grid>
            

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="CNIC Number"
                name="cnicNumber"
                value={formik.values.cnicNumber}
                onChange={formik.handleChange}
                error={formik.touched.cnicNumber && Boolean(formik.errors.cnicNumber)}
                helperText={formik.touched.cnicNumber && formik.errors.cnicNumber}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={4}>
              <TextField
                fullWidth
                label="Contact"
                name="contact"
                value={formik.values.contact}
                onChange={formik.handleChange}
                error={formik.touched.contact && Boolean(formik.errors.contact)}
                helperText={formik.touched.contact && formik.errors.contact}
              />
            </Grid>
        

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Grid>
            <Grid item xs={12} sm={8} >
              <TextField
                fullWidth
                label="Address"
                name="address"
                value={formik.values.address}
                onChange={formik.handleChange}
                error={formik.touched.address && Boolean(formik.errors.address)}
                helperText={formik.touched.address && formik.errors.address}
              />
            </Grid>
          
            <Grid item sm={1}  >
              <TextField
                fullWidth
                label="Age"
                name="age"
                value={formik.values.age}
                onChange={formik.handleChange}
                error={formik.touched.age && Boolean(formik.errors.age)}
                helperText={formik.touched.age && formik.errors.age}
              />
            </Grid>

        
              <Grid item sm={6}>
                <FormLabel>Gender</FormLabel>
                <RadioGroup name="gender" value={formik.values.gender} onChange={formik.handleChange} row>
                <FormControlLabel value="male" control={<Radio />} label="Male" />
                <FormControlLabel value="female" control={<Radio />} label="Female" />
                </RadioGroup>
               </Grid>
            

            
            <Grid item xs={12} sm={6} md={10}><label>DETAILS OF DEGREE PROGRAM WITH THE INSTITUTE DETAILS</label></Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Secondary School"
                name="secondarySchool"
                value={formik.values.secondarySchool}
                onChange={formik.handleChange}
                error={formik.touched.secondarySchool && Boolean(formik.errors.secondarySchool)}
                helperText={formik.touched.secondarySchool && formik.errors.secondarySchool}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Higher School"
                name="higherSchool"
                value={formik.values.higherSchool}
                onChange={formik.handleChange}
                error={formik.touched.higherSchool && Boolean(formik.errors.higherSchool)}
                helperText={formik.touched.higherSchool && formik.errors.higherSchool}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="University"
                name="university"
                value={formik.values.university}
                onChange={formik.handleChange}
                error={formik.touched.university && Boolean(formik.errors.university)}
                helperText={formik.touched.university && formik.errors.university}
              />
              
            </Grid>
            <Grid item xs={12} sm={6} md={10}><label>DETAILS OF DEGREE PROGRAM WITH THE INSTITUTE DETAILS</label></Grid>
            
          
            <Grid item xs={12} sm={6} >
              <TextField
                fullWidth
                label="Discipline"
                name="discipline"
                value={formik.values.discipline}
                onChange={formik.handleChange}
                error={formik.touched.discipline && Boolean(formik.errors.discipline)}
                helperText={formik.touched.discipline && formik.errors.discipline}
              />
            </Grid>

            <Grid item xs={12} sm={6} >
              <TextField
                fullWidth
                label="Degree"
                name="degree"
                value={formik.values.degree}
                onChange={formik.handleChange}
                error={formik.touched.degree && Boolean(formik.errors.degree)}
                helperText={formik.touched.degree && formik.errors.degree}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Name of Institute"
                name="nameOfInstitute"
                value={formik.values.nameOfInstitute}
                onChange={formik.handleChange}
                error={formik.touched.nameOfInstitute && Boolean(formik.errors.nameOfInstitute)}
                helperText={formik.touched.nameOfInstitute && formik.errors.nameOfInstitute}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Recognized By"
                name="recognizedBy"
                value={formik.values.recognizedBy}
                onChange={formik.handleChange}
                error={formik.touched.recognizedBy && Boolean(formik.errors.recognizedBy)}
                helperText={formik.touched.recognizedBy && formik.errors.recognizedBy}
              />
            </Grid>

            <Grid item xs={12} sm={6} >
              <TextField
                fullWidth
                label="Tuition Fee"
                name="tuitionFee"
                value={formik.values.tuitionFee}
                onChange={formik.handleChange}
                error={formik.touched.tuitionFee && Boolean(formik.errors.tuitionFee)}
                helperText={formik.touched.tuitionFee && formik.errors.tuitionFee}
              />
            </Grid>

            <Grid item xs={12} sm={6} >
              <TextField
                fullWidth
                label="Admission Fee"
                name="admissionFee"
                value={formik.values.admissionFee}
                onChange={formik.handleChange}
                error={formik.touched.admissionFee && Boolean(formik.errors.admissionFee)}
                helperText={formik.touched.admissionFee && formik.errors.admissionFee}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Tuition Fee in Words"
                name="tuitionFeeW"
                value={formik.values.tuitionFeeW}
                onChange={formik.handleChange}
                error={formik.touched.tuitionFeeW && Boolean(formik.errors.tuitionFeeW)}
                helperText={formik.touched.tuitionFeeW && formik.errors.tuitionFeeW}
              />
            </Grid>
            </Grid>

            <Grid item xs={12}>
            <label>How much tuition fees can you pay per semester?</label>
            <div>
                {["0%", "1-5%", "5-10%", "10-15%", "Other"].map((option) => (
                  <FormControlLabel
                    key={option}
                    control={
                      <Checkbox
                        checked={formik.values.tuitionFee === option}
                        onChange={() => formik.setFieldValue("tuitionFee", option)}
                      />
                    }
                    label={option}
                  />
                ))}
                {formik.values.tuitionFee === "Other" && (
                  <TextField
                    name="otherPercentage"
                    label="Other %"
                    variant="outlined"
                    size="small"
                    value={formik.values.otherPercentage}
                    onChange={formik.handleChange}
                    error={formik.touched.otherPercentage && Boolean(formik.errors.otherPercentage)}
                    helperText={formik.touched.otherPercentage && formik.errors.otherPercentage}
                  />
                )}
              </div>
              <Grid/>

            <Grid item xs={12}>
              <label>HAVE YOU EVER BEEN AWARDED ANY OTHER SCHOLARSHIP BEFORE?</label>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formik.values.hasScholarship}
                    onChange={(e) => formik.setFieldValue("hasScholarship", e.target.checked)}
                  />
                }
                label="YES"
              />  

              <FormControlLabel
                control={
                  <Checkbox
                    checked={!formik.values.hasScholarship}
                    onChange={() => formik.setFieldValue("hasScholarship", false)}
                  />
                }
                label="NO"
              />
            </Grid>

      <Grid item xs={12}style={{ backgroundColor: 'transparent' }}>
      <h4>(If yes, fill the details of scholarships below)</h4>
      <TableContainer component={Paper} style={{ backgroundColor: 'transparent'}}>
        <Table sx={{ minWidth: 650 }} aria-label="editable table">
          <TableHead>
            <TableRow>
              <TableCell>S.No</TableCell>
              <TableCell>Name of Institute</TableCell>
              <TableCell>Total Amount</TableCell>
              <TableCell>Duration</TableCell>
              <TableCell>Degree</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.id}</TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    value={row.nameOfInstitute}
                    onChange={(e) =>
                      handleTableChange(row.id, 'nameOfInstitute', e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    value={row.totalAmount}
                    onChange={(e) =>
                      handleTableChange(row.id, 'totalAmount', e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    value={row.duration}
                    onChange={(e) =>
                      handleTableChange(row.id, 'duration', e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    value={row.degree}
                    onChange={(e) =>
                      handleTableChange(row.id, 'degree', e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  {/* Delete button */}
                  <IconButton
                    aria-label="delete"
                    onClick={() => handleDeleteRow(row.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Button
        variant="contained"
        color="secondary"
        onClick={addRow}
        style={{ marginTop: '10px' }}
      >
        Add Row
      </Button>
    </Grid>
 


            <Grid container spacing={4}>
             <Grid item xs={12} ><label>DETAILS OF DEGREE PROGRAM WITH THE INSTITUTE DETAILS</label></Grid>
           
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Father's / Guardian's Name"
                name="fatherName"
                value={formik.values.fatherName}
                onChange={formik.handleChange}
                error={formik.touched.fatherName && Boolean(formik.errors.fatherName)}
                helperText={formik.touched.fatherName && formik.errors.fatherName}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Cnic Number"
                name="f_Cnic"
                value={formik.values.f_Cnic}
                onChange={formik.handleChange}
                error={formik.touched.f_Cnic && Boolean(formik.errors.f_Cnic)}
                helperText={formik.touched.f_Cnic && formik.errors.f_Cnic}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Present Occupation"
                name="p_occupation"
                value={formik.values.P_occupation}
                onChange={formik.handleChange}
                error={formik.touched.secondarySchool && Boolean(formik.errors.secondarySchool)}
                helperText={formik.touched.secondarySchool && formik.errors.secondarySchool}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Designation"
                name="designation"
                value={formik.values.designation}
                onChange={formik.handleChange}
                error={formik.touched.designation && Boolean(formik.errors.designation)}
                helperText={formik.touched.designation && formik.errors.designation}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Employer"
                name="employer"
                value={formik.values.employer}
                onChange={formik.handleChange}
                error={formik.touched.employer && Boolean(formik.errors.employer)}
                helperText={formik.touched.employer && formik.errors.employer}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Monthly Income"
                name="p_m_income"
                value={formik.values.P_m_income}
                onChange={formik.handleChange}
                error={formik.touched.P_m_income && Boolean(formik.errors.P_m_income)}
                helperText={formik.touched.P_m_income && formik.errors.P_m_income}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Parent Contact"
                name="P_contact"
                value={formik.values.P_contact}
                onChange={formik.handleChange}
                error={formik.touched.P_contact && Boolean(formik.errors.P_contact)}
                helperText={formik.touched.P_contact && formik.errors.P_contact}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Pension(If Retired)"
                name="pension"
                value={formik.values.pension}
                onChange={formik.handleChange}
                error={formik.touched.pension && Boolean(formik.errors.pension)}
                helperText={formik.touched.pension && formik.errors.pension}
              />
            </Grid> 
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Family Members"
                name="family_members"
                value={formik.values.family_member}
                onChange={formik.handleChange}
                error={formik.touched.family_member && Boolean(formik.errors.family_member)}
                helperText={formik.touched.family_member && formik.errors.family_member}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={10}><label>MOTHER; HOUSE WIFE OR WORKING WOMAN</label></Grid>
            <Grid item xs={12} sm={6} md={10}><label>PRESENT OCCUPATION (if any)</label></Grid>

            <Grid item xs={12} sm={6} >
              <TextField
                fullWidth
                label="Monthly Income"
                name="m_monthlyIncome"
                value={formik.values.M_monthlyIncome}
                onChange={formik.handleChange}
                error={formik.touched.M_monthlyIncome && Boolean(formik.errors.M_monthlyIncome)}
                helperText={formik.touched.M_monthlyIncome && formik.errors.M_monthlyIncome}
              />
            </Grid>
            <Grid item xs={12} sm={6} >
              <TextField
                fullWidth
                label="Pension(If retired)"
                name="M_pension"
                value={formik.values.M_pension}
                onChange={formik.handleChange}
                error={formik.touched.M_pension && Boolean(formik.errors.M_pension)}
                helperText={formik.touched.M_pension && formik.errors.M_pension}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={10}><label>Siblings</label></Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label=" BRO/SIS (elder/younger):"
                name="s1"
                value={formik.values.s1}
                onChange={formik.handleChange}
                error={formik.touched.s1 && Boolean(formik.errors.s1)}
                helperText={formik.touched.s1 && formik.errors.s1}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="INSTITUE"
                name="instiute1"
                value={formik.values.institue1}
                onChange={formik.handleChange}
                error={formik.touched.institue1 && Boolean(formik.errors.institue1)}
                helperText={formik.touched.institue1 && formik.errors.institue1}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="OCCUPATION / DESIGNATION"
                name="occ1"
                value={formik.values.occ1}
                onChange={formik.handleChange}
                error={formik.touched.occ1 && Boolean(formik.errors.occ1)}
                helperText={formik.touched.occ1 && formik.errors.occ1}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="FEE/EARNING"
                name="fee1"
                value={formik.values.fee1}
                onChange={formik.handleChange}
                error={formik.touched.fee1 && Boolean(formik.errors.fee1)}
                helperText={formik.touched.fee1 && formik.errors.fee1}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label=" BRO/SIS (elder/younger):"
                name="s2"
                value={formik.values.s2}
                onChange={formik.handleChange}
                error={formik.touched.s2 && Boolean(formik.errors.s2)}
                helperText={formik.touched.s2 && formik.errors.s2}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="INSTITUE"
                name="institue2"
                value={formik.values.institue2}
                onChange={formik.handleChange}
                error={formik.touched.institue2 && Boolean(formik.errors.institue2)}
                helperText={formik.touched.institue2 && formik.errors.institue2}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="OCCUPATION / DESIGNATION"
                name="M_pension"
                value={formik.values.occ2}
                onChange={formik.handleChange}
                error={formik.touched.occ2 && Boolean(formik.errors.occ2)}
                helperText={formik.touched.occ2 && formik.errors.occ2}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="FEE/EARNING"
                name="fee2"
                value={formik.values.fee2}
                onChange={formik.handleChange}
                error={formik.touched.fee2 && Boolean(formik.errors.fee2)}
                helperText={formik.touched.fee2 && formik.errors.fee2}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label=" BRO/SIS (elder/younger):"
                name="s3"
                value={formik.values.s3}
                onChange={formik.handleChange}
                error={formik.touched.s3 && Boolean(formik.errors.s3)}
                helperText={formik.touched.s3 && formik.errors.s3}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="INSTITUE"
                name="institue3"
                value={formik.values.institue3}
                onChange={formik.handleChange}
                error={formik.touched.institue3 && Boolean(formik.errors.institue3)}
                helperText={formik.touched.institue3 && formik.errors.institue3}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="OCCUPATION / DESIGNATION"
                name="occ3"
                value={formik.values.occ3}
                onChange={formik.handleChange}
                error={formik.touched.occ3 && Boolean(formik.errors.occ3)}
                helperText={formik.touched.occ3 && formik.errors.occ3}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="FEE/EARNING"
                name="fee3"
                value={formik.values.fee3}
                onChange={formik.handleChange}
                error={formik.touched.fee3 && Boolean(formik.errors.fee3)}
                helperText={formik.touched.fee3 && formik.errors.fee3}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label=" BRO/SIS (elder/younger):"
                name="s4"
                value={formik.values.s4}
                onChange={formik.handleChange}
                error={formik.touched.s4 && Boolean(formik.errors.s4)}
                helperText={formik.touched.s4 && formik.errors.s4}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="INSTITUE"
                name="institue4"
                value={formik.values.institue4}
                onChange={formik.handleChange}
                error={formik.touched.institue4 && Boolean(formik.errors.institue4)}
                helperText={formik.touched.institue4 && formik.errors.institue4}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="OCCUPATION / DESIGNATION"
                name="occ4"
                value={formik.values.occ4}
                onChange={formik.handleChange}
                error={formik.touched.occ4 && Boolean(formik.errors.occ4)}
                helperText={formik.touched.occ4 && formik.errors.occ4}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label=" FEE/EARNING"
                name="fee4"
                value={formik.values.fee4}
                onChange={formik.handleChange}
                error={formik.touched.fee4 && Boolean(formik.errors.fee4)}
                helperText={formik.touched.fee4 && formik.errors.fee4}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={10}><label>SECTION C: FINANCIAL DETAILS</label></Grid>
            <Grid item xs={12} sm={6} md={10}><label>ACCOMODATION TYPE</label></Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label=" Appartment"
                name="appartment"
                value={formik.values.appartment}
                onChange={formik.handleChange}
                error={formik.touched.appartment && Boolean(formik.errors.appartment)}
                helperText={formik.touched.appartment && formik.errors.appartment}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label=" House"
                name="house"
                value={formik.values.house}
                onChange={formik.handleChange}
                error={formik.touched.house && Boolean(formik.errors.house)}
                helperText={formik.touched.house && formik.errors.house}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="Family Owned"
                name="family_owned"
                value={formik.values.family_owned}
                onChange={formik.handleChange}
                error={formik.touched.family_owned && Boolean(formik.errors.family_owned)}
                helperText={formik.touched.family_owned && formik.errors.family_owned}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                label="Rented"
                name="rented"
                value={formik.values.rented}
                onChange={formik.handleChange}
                error={formik.touched.rented && Boolean(formik.errors.rented)}
                helperText={formik.touched.rented && formik.errors.rented}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={10}><label>ACCOMODATION OWNERSHIP</label></Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Joint Family"
                name="joint_family"
                value={formik.values.joint_family}
                onChange={formik.handleChange}
                error={formik.touched.joint_family && Boolean(formik.errors.joint_family)}
                helperText={formik.touched.joint_family && formik.errors.joint_family}
              />
            </Grid>
            <Grid item xs={12} sm={6} >
              <TextField
                fullWidth
                label="Independent Family"
                name="indepent_family"
                value={formik.values.independent_family}
                onChange={formik.handleChange}
                error={formik.touched.independent_family && Boolean(formik.errors.independent_family)}
                helperText={formik.touched.independent_family && formik.errors.independent_family}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={10}><label>DETAILS OF LIABILITIES (MENTION CURRENT MARKET VALUES) </label></Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Amount Outstanding"
                name="amount_outstanding"
                value={formik.values.amount_outstanding}
                onChange={formik.handleChange}
                error={formik.touched.fee4 && Boolean(formik.errors.fee4)}
                helperText={formik.touched.fee4 && formik.errors.fee4}
              />
            </Grid>
            <Grid item xs={12} sm={6} >
              <TextField
                fullWidth
                label="Nature of loan"
                name="nature_of_loan"
                value={formik.values.nature_of_loan}
                onChange={formik.handleChange}
                error={formik.touched.nature_of_loan && Boolean(formik.errors.nature_of_loan)}
                helperText={formik.touched.nature_of_loan && formik.errors.nature_of_loan}
              />
            </Grid>
            </Grid>

            <Grid item xs={12} style={{ backgroundColor: 'transparent' }}>
      <h4>(FAMILY INCOME (PLEASE ATTACH SUPPORTS AND GIVE FULL DETAILS IN RUPEES))</h4>
      <TableContainer component={Paper} style={{ backgroundColor: 'transparent' }}>
        <Table sx={{ minWidth: 650 }} aria-label="editable table">
          <TableHead>
            <TableRow>
              <TableCell>Average Monthly Income Arising from:</TableCell>
              <TableCell>Father</TableCell>
              <TableCell>Mother</TableCell>
              <TableCell>Spouse</TableCell>
              <TableCell>Self</TableCell>
              <TableCell>Bro/sis/children/others</TableCell>
              <TableCell>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {familyincomeTableData.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.incomeSource}</TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    value={row.father}
                    onChange={(e) =>
                      handlefamilyincomeTableChange(row.id, 'father', e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    value={row.mother}
                    onChange={(e) =>
                      handlefamilyincomeTableChange(row.id, 'mother', e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    value={row.spouse}
                    onChange={(e) =>
                      handlefamilyincomeTableChange(row.id, 'spouse', e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    value={row.self}
                    onChange={(e) =>
                      handlefamilyincomeTableChange(row.id, 'self', e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    value={row.others}
                    onChange={(e) =>
                      handlefamilyincomeTableChange(row.id, 'others', e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    value={row.total}
                    onChange={(e) =>
                      handlefamilyincomeTableChange(row.id, 'total', e.target.value)
                    }
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>

           <Grid item xs={12} style={{ backgroundColor: 'transparent' }}>
      <h4>(FAMILY EXPENDITURES (PLEASE ATTACH SUPPORTS AND GIVE FULL DETAILS IN RUPEES))</h4>
      <TableContainer component={Paper} style={{ backgroundColor: 'transparent' }}>
        <Table sx={{ minWidth: 650 }} aria-label="editable table">
          <TableHead>
            <TableRow>
              <TableCell>S.No</TableCell>
              <TableCell>Brother/ sister/ children/ other dependants</TableCell>
              <TableCell>Age</TableCell>
              <TableCell>Occupation if any</TableCell>
              <TableCell>Name of institute (if any)</TableCell>
              <TableCell>Fee (per month)</TableCell>
              <TableCell>Others</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {familyTableData.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.id}</TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    value={row.dependant}
                    onChange={(e) =>
                      handlefamilyTableChange(row.id, 'dependant', e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    value={row.age}
                    onChange={(e) =>
                      handlefamilyTableChange(row.id, 'age', e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    value={row.occupation}
                    onChange={(e) =>
                      handlefamilyTableChange(row.id, 'occupation', e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    value={row.nameOfInstitute}
                    onChange={(e) =>
                      handlefamilyTableChange(row.id, 'nameOfInstitute', e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    value={row.feePerMonth}
                    onChange={(e) =>
                      handlefamilyTableChange(row.id, 'feePerMonth', e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    value={row.others}
                    onChange={(e) =>
                      handlefamilyTableChange(row.id, 'others', e.target.value)
                    }
                  />
                </TableCell>
                <TableCell>
                  <IconButton
                    aria-label="delete"
                    onClick={() => handleDeleteRow2(row.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button
        variant="contained"
        color="secondary"
        onClick={add2Row}
        style={{ marginTop: '10px' }}
      >
        Add Row
      </Button>
    </Grid>
  
           <Grid container spacing={4}>

             <Grid item xs={12} ><label>NCASE OF RENTED ACCOMODATION</label></Grid>
           
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="WHAT IS THE MONTHLY RENT"
                name="monthly_rent"
                value={formik.values.monthly_rent}
                onChange={formik.handleChange}
                error={formik.touched.monthly_rent && Boolean(formik.errors.monthly_rent)}
                helperText={formik.touched.monthly_rent && formik.errors.monthly_rent}
              />
            </Grid>
            <Grid item xs={12} ><label>UTILITIES EXPENDITURE (AVERAGE OF LAST SIX MONTHS BILLS)</label></Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Telephone"
                name="telephone"
                value={formik.values.telephone}
                onChange={formik.handleChange}
                error={formik.touched.telephone && Boolean(formik.errors.telephone)}
                helperText={formik.touched.telephone && formik.errors.telephone}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Gas"
                name="gas"
                value={formik.values.gas}
                onChange={formik.handleChange}
                error={formik.touched.gas && Boolean(formik.errors.gas)}
                helperText={formik.touched.gas && formik.errors.gas}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Electricity"
                name="electricity"
                value={formik.values.electricity}
                onChange={formik.handleChange}
                error={formik.touched.electricity && Boolean(formik.errors.electricity)}
                helperText={formik.touched.electricity && formik.errors.electricity}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Water"
                name="water"
                value={formik.values.water}
                onChange={formik.handleChange}
                error={formik.touched.water && Boolean(formik.errors.water)}
                helperText={formik.touched.water && formik.errors.water}
              />
            </Grid>
          
            <Grid item xs={12}>
            <label>What are your career goals after completion of graduation?</label>
              <TextField
                fullWidth
               
                name="telephone"
                value={formik.values.telephone}
                onChange={formik.handleChange}
                error={formik.touched.telephone && Boolean(formik.errors.telephone)}
                helperText={formik.touched.telephone && formik.errors.telephone}
              />
            </Grid>
            <Grid item xs={12}>
            <label>Where do you see yourself in your life after ten years from now?</label>
              <TextField
                fullWidth
               
                name="telephone"
                value={formik.values.telephone}
                onChange={formik.handleChange}
                error={formik.touched.telephone && Boolean(formik.errors.telephone)}
                helperText={formik.touched.telephone && formik.errors.telephone}
              />
            </Grid>
            <Grid item xs={12}>
            <label>Enlist major acheivement you have till date?</label>
              <TextField
                fullWidth
               
                name="telephone"
                value={formik.values.telephone}
                onChange={formik.handleChange}
                error={formik.touched.telephone && Boolean(formik.errors.telephone)}
                helperText={formik.touched.telephone && formik.errors.telephone}
              />
            </Grid>
            <Grid item xs={12}>
            <label>What were your motivation in chosing this college/university?</label>
              <TextField
                fullWidth
              
                name="telephone"
                value={formik.values.telephone}
                onChange={formik.handleChange}
                error={formik.touched.telephone && Boolean(formik.errors.telephone)}
                helperText={formik.touched.telephone && formik.errors.telephone}
              />
            </Grid>
            <Grid  item xs={12}>
            <label>Why do you think you deserve this scholarship?</label>
              <TextField
                fullWidth
               
                name="telephone"
                value={formik.values.telephone}
                onChange={formik.handleChange}
                error={formik.touched.telephone && Boolean(formik.errors.telephone)}
                helperText={formik.touched.telephone && formik.errors.telephone}
              />
            </Grid>
            </Grid>
            
            <Grid item xs={12}>
              <Button type="submit" variant="contained" color="primary">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </FormikProvider>
    </div>
  );
};

export default App;